<template>
  <div class="sorry-message-wrapper">
    <div class="sorry-message">
      <p>{{ "charts.errorMessage.sorryMessage1" | t }}</p>
      <p>{{ "charts.errorMessage.sorryMessage2" | t }}</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.sorry-message-wrapper {
  height: 100%;
}

.sorry-message {
  position: absolute;
  top: 50%;
  width: 100%;
  margin: 0;
  font-size: 15px;
  text-align: center;
  transform: translateY(-50%);
}
</style>
